import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { ptBR } from "@mui/x-date-pickers/locales";
import { TextField } from "@mui/material";

function GenericDatePickerReference(props) {
  const {
    label,
    value,
    onChange,
    placeholder,
    required,
    error,
    helperText,
    ariaLabel,
    ...rest
  } = props;

  const handleChange = (dayJSdate) => {
    if (!dayJSdate) {
      onChange(null);
      return;
    }
    const dateVal = dayJSdate.startOf("month").toDate();
    onChange(dateVal);
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-br"
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DatePicker
        readOnly={false}
        views={["year", "month"]}
        slotProps={{
          field: { readOnly: false },
          textField: {
            size: "small",
            fullWidth: true,
            error: !!error,
            helperText: helperText,
            inputProps: {
              "data-skip-guards": "true",
              ...(ariaLabel ? { "aria-label": ariaLabel } : {}),
            },
          },
        }}
        label={`${label || ""}${required ? " *" : ""}`}
        variant="outlined"
        size="small"
        InputLabelProps={{ shrink: true }}
        format="MM/YYYY"
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        placeholder={placeholder}
        {...rest}
      />
    </LocalizationProvider>
  );
}

export default GenericDatePickerReference;